import React from "react";

const DownArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.577"
      height="6.531"
      viewBox="0 0 10.577 6.531"
    >
      <path
        id="ic_expand_less_24px"
        d="M11.288,14.531,6,9.243,7.243,8l4.046,4.037L15.334,8l1.243,1.243Z"
        transform="translate(-6 -8)"
      />
    </svg>
  );
};

export default DownArrow;
